import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {Store} from '@ngrx/store';
import {getGroupingSymbol, getIfeDomain, State} from '../../reducers/index';
import urlJoin from 'proper-url-join';
import {CbsRollbarService} from '../../rollbar/cbs-rollbar.service';
import {HeaderFieldChangeResponse} from './header-field-change-response';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {map} from 'rxjs/operators';
import {assignFirstTruthy} from '../../util/rx-utils';

@Injectable()
export class HeaderService {
  private ifeDomain: string;
  private groupingSymbol: string;

  constructor(private httpClient: HttpClient, private store: Store<State>, private rollbar: CbsRollbarService) {
    assignFirstTruthy(this.store, getIfeDomain, ifeDomain => this.ifeDomain = ifeDomain);
    assignFirstTruthy(this.store, getGroupingSymbol, symbol => this.groupingSymbol = symbol);
  }

  submitHeaderFieldChange(params: string[][]): Observable<HeaderFieldChangeResponse> {
    const headers = new HttpHeaders({'Content-Type': 'application/x-www-form-urlencoded'});
    const options = {headers: headers, withCredentials: true};
    let urlParams = new HttpParams();
    params.forEach(([key, value]) => {
      if (key.includes('numeric_')) {
        value = value.replace(this.groupingSymbol, '');
      }
      urlParams = urlParams.set(key, value);
    });
    return this.httpClient
      .post(getHeaderOptionSubmitUrl(this.ifeDomain), urlParams, options)
      .pipe(map(data => <HeaderFieldChangeResponse>data));
  }
}

function getHeaderOptionSubmitUrl(ifeDomain: string): string {
  return urlJoin(ifeDomain, '/config/api/v1/cbs/header-option');
}
